import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import React from 'react';
import useCcWebviewUtilsHelper from '@di-shared/features/common/useCcWebviewUtilsHelper';
import HeaderCloseButton from '@di-shared/features/common/HeaderCloseButton';
import Header from '@di-shared/features/common/Header';
import usePendingHandler from '@shared/usePendingHandler';
import {diApi} from '@di-shared/api/di';
import useUnitConverter from '@di-shared/utils/useUnitConverter';
import useOdometer from '@di-shared/features/mileage/useOdometer';
import {formatNumberWithCommas} from '@di-shared/utils';

interface MileageMidRegisterProps {
  vin: string;
}

function MileageMidRegister({vin}: MileageMidRegisterProps) {
  const {t} = useInferableTranslation();
  const {openAlert, backOrClose} = useCcWebviewUtilsHelper();
  const {odometer} = useOdometer(vin);
  const {convertDistanceValue, convertDistanceSymbol} = useUnitConverter();

  const [register] = usePendingHandler(
    async () => {
      await diApi.ecoMileageController.updateVehicleLink({vin, requestBody: {vin}});
      await openAlert({
        title: t('T30388'),
        message: t('T30389'),
      });
      backOrClose();
    },
    async () => {
      await openAlert({
        title: t('T30390'),
        message: t('T30391_$tel', {tel: import.meta.env.VITE_EMERGENCY_TEL_BRAND}),
      });
      backOrClose();
    }
  );

  return (
    <>
      <Header
        right={
          <HeaderCloseButton
            onClick={() => {
              backOrClose();
            }}
          />
        }
      >
        <h1 className="title_xsmall_b nav_center_title">{t('T10122')}</h1>
      </Header>
      <main
        id="content"
        className="content page_eco_mileage"
      >
        <section className="section section_mileage_submit">
          <div className="section_heading type_main">
            <h2 className="section_heading_title">
              {t('T10033')}
              <br />
              {formatNumberWithCommas(convertDistanceValue(odometer))} {convertDistanceSymbol(odometer)}
            </h2>
          </div>
          <div className="mileage_submit_box type_dot">
            <p className="mileage_submit_desc">{t('T30392')}</p>
            <p className="mileage_submit_desc">{t('T30393')}</p>
          </div>
        </section>
      </main>
      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={register}
        >
          {t('T30394')}
        </button>
      </div>
    </>
  );
}

function MileageMidRegisterLoading() {
  const {backOrClose} = useCcWebviewUtilsHelper();
  const {t} = useInferableTranslation();
  return (
    <>
      <Header
        right={
          <HeaderCloseButton
            onClick={() => {
              backOrClose();
            }}
          />
        }
      >
        <h1 className="title_xsmall_b nav_center_title">{t('T10122')}</h1>
      </Header>
      <main
        id="content"
        className="content page_eco_mileage"
      >
        <section className="section section_mileage_submit">
          <div className="section_heading type_main">
            <h2 className="section_heading_title">{t('T10033')}</h2>
            <span
              className="skeleton"
              style={{width: 120, height: 30}}
            />
          </div>
          <div
            className="mileage_submit_box type_dot skeleton"
            style={{height: 80}}
          ></div>
        </section>
      </main>
      <div className="floating_action_area">
        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          disabled
        >
          {t('T30394')}
        </button>
      </div>
    </>
  );
}

MileageMidRegister.Loading = MileageMidRegisterLoading;
export default MileageMidRegister;
